// src/pages/AnyToAnyConverter.js
import React from 'react';
import MiniToolPageLayout from '../components/MiniToolPageLayout';
import AnyToAnyConverter from '../components/AnyToAnyConverter'; // The tool component
import { IoSwapHorizontalOutline } from 'react-icons/io5';
// ✅ Removed unused 'heroBg' import
import heroBg from '../assets/images/any-to-any-converter-background.png';

// --- Page-Specific Data ---
const pageData = {
  seo: {
    title: "Free Online File Converter | Any-to-Any | Oolook",
    description: "Convert any file format online for free. Oolook's Any-to-Any converter handles images, videos, documents, and audio with a simple, secure interface.",
    image: 'https://oolook.in/og/any-to-any-converter.png',
    schemas: [{
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Any-to-Any File Converter",
      "operatingSystem": "All",
      "applicationCategory": "Utility",
      "description": "A free online tool to convert between various file formats including images, videos, documents, and audio.",
      "url": "https://oolook.in/any-to-any-converter",
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    }]
  },
  hero: {
    icon: IoSwapHorizontalOutline,
    title: "Any-to-Any Converter",
    subtitle: "Effortlessly convert images, videos, documents, and audio files between dozens of formats. Fast, secure, and entirely free.",
    // ✅ Make sure the background image is passed to the hero
    backgroundImage: heroBg,
  },
  guide: {
    title: "How It Works",
    subtitle: "Seamless file conversion in three easy steps.",
    steps: [
      { title: "1. Upload Your Files", description: "Drag and drop your files or select them from your device. You can upload multiple files, but they must be of the same category (e.g., all images)." },
      { title: "2. Choose Your Output Format", description: "For each file, select the desired format you want to convert to from the dropdown menu. The conversion will start automatically." },
      { title: "3. Download Your Files", description: "Once the conversion is complete, download your files individually or get them all at once in a convenient .zip archive." }
    ]
  }
};

const AnyToAnyConverterPage = () => {
  return (
    <MiniToolPageLayout seo={pageData.seo} hero={pageData.hero} guide={pageData.guide}>
      <AnyToAnyConverter />
    </MiniToolPageLayout>
  );
};

export default AnyToAnyConverterPage;